import React from 'react'
import Box from '@mui/material/Box'

import MobileExpandableDetailCard from './MobileExpandableDetailCard'

export default function MobileListItemCard({
  className = '',
  sx,
  actionContent = null,
  actionAlign = 'flex-end',
  actionPaddingTop = 1.25,
  actionPlacement = 'bottom',
  bottomContent = null,
  ...cardProps
}) {
  const actionSlot = actionContent ? (
    <Box onClick={(event) => event.stopPropagation()}>{actionContent}</Box>
  ) : null

  const resolvedBottomContent =
    bottomContent || (actionPlacement === 'bottom' && actionSlot) ? (
      <Box
        sx={{
          display: 'flex',
          justifyContent: actionAlign,
          alignItems: 'center',
          minWidth: 0,
          gap: 1
        }}
      >
        {bottomContent}
        {actionPlacement === 'bottom' ? actionSlot : null}
      </Box>
    ) : null

  return (
    <Box
      className={className}
      sx={{
        width: '100%',
        minWidth: 0,
        display: 'flex',
        alignItems: 'stretch',
        ...(sx || {})
      }}
    >
      <MobileExpandableDetailCard
        {...cardProps}
        bottomContent={resolvedBottomContent}
        bottomContentPaddingTop={actionPaddingTop}
        footerActionContent={actionPlacement === 'footer' ? actionSlot : null}
      />
    </Box>
  )
}
